import HomeContent from './HomeContent'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setRegionsData: regionsData => dispatch(ReduxActions.setRegionsData(regionsData)),
    setCountriesData: countriesData => dispatch(ReduxActions.setCountriesData(countriesData)),
    setSelectedRegionId: selectedRegionId => dispatch(ReduxActions.setSelectedRegionId(selectedRegionId)),
    setIndicatorsLastUpdated: lastUpdated => dispatch(ReduxActions.setIndicatorsLastUpdated(lastUpdated))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HomeContent)
)



// WEBPACK FOOTER //
// ./src/modules/HomeContent/index.js